var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.doCheckIn}},[_c('Button',{attrs:{"type":"warning","plain":"","round":"","size":"small","disabled":_vm.isCheckIn? true: false}},[_vm._v(_vm._s(_vm.checkinText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }